import { Component, OnInit, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ApiService } from '../shared/api.service';
import {FormBuilder, FormGroup, Validators, FormControl, AbstractControl} from '@angular/forms';
import { TweenMax } from "gsap";
import { SuscripcionBoletaElectronica } from '../shared/suscripcion-boleta-electronica';
import { UploaderService } from "../shared/uploader.service";
import { DeleterService } from "../shared/deleter.service";
import * as basicLightbox from 'basiclightbox';
import * as $ from 'jquery';
import { RutService } from '../shared/rut.service';
import {rutValidator, numClienteValidator, ValidatorService} from '../shared/validator-service.service';
import { requiredFileType } from '../shared/requiredFileType.service';
import { GlobalConstants } from '../shared/global-constants';
import { NgxSpinnerService } from 'ngx-spinner';
import { Title } from '@angular/platform-browser';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../environments/environment';
import {Observable, of, timer} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import { interval, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ModalNumeroClientesComponent } from '../modales/modal-numero-clientes/modal-numero-clientes.component';
import { Router } from '@angular/router';
import { ModalPoliticaPrivacidadComponent } from '../modales/modal-politica-privacidad/modal-politica-privacidad.component';

@Component({
  selector: 'app-suscripcion-boleta-electronica',
  templateUrl: './suscripcion-boleta-electronica.component.html',
  styleUrls: ['./suscripcion-boleta-electronica.component.scss']
})
export class SuscripcionBoletaElectronicaComponent implements OnInit {
  fileCedulaIdentidad: File = null;
  formData: FormGroup;
  submitted = false;
  pasos: any;
  respuesta: any;
  plazo: number;
  userIp: string = '';

  public mimeTypes = ValidatorService.mimeTypes;

  public dataComuna: Array<any>;
  public dataRegion: Array<any>;
  @ViewChild('comuna') comuna;

  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);

  subscription: Subscription;
  intentos = 0;

  public  spinnerMsg = '';
  isGuardarDisabled: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private rutService: RutService,
    private spinner: NgxSpinnerService,
    private titleService: Title,
    private metaService: Meta,
    private recaptchaV3Service: ReCaptchaV3Service,
    @Inject(PLATFORM_ID) private platformId: any,
    private gtmService: GoogleTagManagerService,
    private dialog: MatDialog,
    private router: Router
  ) {
    // PASOS DE LA VISTA
    this.pasos = [{
      "P1": {
        //*DevFun* Init
        "I": true,
        "CurrentNum": true
      },
      "P2": {
        "I": false,
        "CurrentNum": false
      },
      "P3": {
        "I": false,
        "CurrentNum": false
      }
    }]
  }

  ngAfterViewInit(){
    //@ts-ignore
    $('.videsk-top-container').css('display', 'none');
  }

  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    // CONTROLS FORMULARIO PASO 2
    this.formData = this.formBuilder.group({
      nombre: ['', [Validators.required, Validators.pattern(ValidatorService.nombre)]],
      rut: ['', [Validators.minLength(3), Validators.maxLength(12), Validators.required, rutValidator]],
      telefono: ['', [Validators.maxLength(9), Validators.pattern(ValidatorService.telefono)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(200)]],
      nCliente: ['', [Validators.required, Validators.maxLength(9), Validators.pattern(ValidatorService.numeroCliente), numClienteValidator], [this.validarNumeroCliente.bind(this)]],
      direccion: ['', [Validators.required, Validators.pattern(ValidatorService.direccion)]],
      comuna: [{value: null, disabled: true}, [Validators.required]],
      region: [null, [Validators.required]],
      terminos: [false, [Validators.requiredTrue]],
      newsletters: [false],
      privacidad: [true],
      suscripcion: [false]
    });

    // this.formData.valueChanges.subscribe((nCliente) => {
    //   console.log(nCliente);
    // });



    this.titleService.setTitle('Suscripción de boleta electrónica | Metrogas');
    this.metaService.updateTag({ name: 'description', content: 'Cuida el medio ambiente cambiándote aquí a la boleta electrónica de Metrogas, la forma más práctica, cómoda y segura de recibir tu cuenta de gas natural.' })

    if (this.isBrowser) {
      if (environment.production) {
        this.gtmService.addGtmToDom();
      }
      this.gotoPaso(2, null);

      this.apiService.LeerRegion().subscribe(res => {
        if (res.respuesta === true) {
          this.dataRegion = this.generarDataSetRegion(res.data);
        }
      });
    }

  // Buscar plazo
  const indice = this.apiService.configuracion.formularios.findIndex(s => s.nombre === 'Suscripción boleta electrónica');
  this.plazo = this.apiService.configuracion.formularios[indice].plazo;
  //console.log('Plazo', indice, this.apiService.configuracion.formularios[indice]);
  this.getUserIp();
  }



  mostrarTerminos(objeto) {
    this.dialog.open(ModalPoliticaPrivacidadComponent);
  }

  mostrarPrivacidad(objeto) {
    this.lightboxDiv('.modal-privacidad');
  }

  mostrarSuscripcion(objeto) {
    //this.lightboxDiv('.modal-suscripcion');
  }
  mostrarNumeroCliente() {
    const dialogRef = this.dialog.open(ModalNumeroClientesComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result !== 'childClosed') {
        this.formData.patchValue({ nCliente: result });
      }
    });
  }

  lightboxDiv(claseCss) {
    const instance = basicLightbox.create(
      $(claseCss).get()[0].innerHTML, {
      closable: true
    });

    instance.show();
  }

  get f() { return this.formData.controls; }
  onSubmit() {
    this.spinner.show();
    this.submitted = true;
    if (this.formData.invalid) {
      this.lightboxDiv('.modal-requerido');
      this.spinner.hide();
      return;
    } else {
      this.recaptchaV3Service.execute('SubmitSuscripcionBoleta')
        .subscribe(
          (token) => {
            let suscripcionBoletaElectronica = new SuscripcionBoletaElectronica();
            suscripcionBoletaElectronica.rut = this.formatearTextoRut(this.formData.value.rut);
            suscripcionBoletaElectronica.nombre = this.formData.value.nombre;
            suscripcionBoletaElectronica.telefono = this.formData.value.telefono;
            suscripcionBoletaElectronica.email = this.formData.value.email;
            suscripcionBoletaElectronica.numero_cliente = this.formData.value.nCliente;
            suscripcionBoletaElectronica.direccion = this.formData.getRawValue().direccion;
            suscripcionBoletaElectronica.id_comuna = this.formData.getRawValue().comuna;
            suscripcionBoletaElectronica.id_region = this.formData.getRawValue().region;
            //suscripcionBoletaElectronica.acepto_condiciones = this.formData.value.terminos === null ? false : this.formData.value.terminos;
            suscripcionBoletaElectronica.acepto_newsletters = this.formData.value.newsletters === null ? false : this.formData.value.newsletters;
            suscripcionBoletaElectronica.acepto_privacidad = this.formData.value.terminos === null ? false : this.formData.value.terminos;
            //suscripcionBoletaElectronica.acepto_suscripcion = this.formData.value.suscripcion === null ? true : this.formData.value.suscripcion;
            suscripcionBoletaElectronica.acepto_suscripcion = true;
            suscripcionBoletaElectronica.token = token;
            suscripcionBoletaElectronica.ip = this.userIp;

            const formulario = new FormData();
            formulario.append("data", JSON.stringify(suscripcionBoletaElectronica));

            let clientId = this.formData.value.nCliente;
            if (clientId === "") {
              alert(
                'Es necesario ingresar su número de cliente.'
              );
              this.formData.patchValue({
                suscripcion: false
              });
            } else {
              this.apiService.ConsultaSuscripcionBoletaElectronicaIC(clientId).subscribe((response: any) => {
                if (response.Indicador == "NO" || response.TipoTarifa == "Null") {
                  this.formData.patchValue({
                    suscripcion: false
                  });
                  alert(
                    'Estimado cliente, la suscripción electrónica no es factible para este número de cliente.'
                  );
                  this.isGuardarDisabled = true;
                  this.spinner.hide();
                } else {
                  this.apiService.AgregarSuscripcionBoletaElectronica(formulario, suscripcionBoletaElectronica).subscribe(res => {
                    console.log("la respuesta",res)
                    if (res.respuesta === true) {
                      this.spinnerMsg = GlobalConstants.mjeEspera;
                      this.gotoPaso(3, res);
      
                    } else {
                      this.lightboxDiv('.modal-error');
                      this.spinner.hide();
                    }
                  });
                }
              });
            }
          },
          (error) => {
            console.log("error 2", error)
            this.lightboxDiv('.modal-error');
            this.spinner.hide();
          },
        );
    }
  }

  onReset() {
    this.submitted = false;
    this.formData.reset();
  }

  formatearRut(objeto) {
    objeto.target.value = this.rutService.transform(objeto.target.value);
  }

  formatearTextoRut(texto) {
    return (texto === null || texto === undefined) ? "" : this.rutService.transform(texto);
  }

  gotoPaso(index, respuesta) {
    // Imprime la respuesta del backend
    switch (index) {
      case 1:
        break;
      case 2:

        //this.pasos[0]['P1'].I = false;
        this.pasos[0]['P2'].I = true;
        this.pasos[0]['P3'].I = false;
        TweenMax.to('.linea-current', 0.5, {
          width: '50%', onComplete: () => {
            this.pasos[0]['P2'].CurrentNum = true;
            this.pasos[0]['P3'].CurrentNum = false;
            $(".paso-2")[0].scrollIntoView();
          }
        });
        break;
      case 3:
        this.spinner.show();
        const source = interval(2000);
        this.subscription = source.subscribe(val => {
          this.apiService.LeerAviso(respuesta.idTransaccion).subscribe( aviso => {
            let CodigoAprovacion = aviso.Mensajes.item[0].CodMensaje;
            let nombre = this.formData.value.nombre;
            let mail = this.formData.value.email;
            let codigo = aviso.NumAviso
            if (CodigoAprovacion === "000" || CodigoAprovacion === "002") {
              this.sendEmail(nombre ,mail, codigo );
            }
            if( aviso != null && aviso !== 'null'){
              this.subscription.unsubscribe();
              this.gotoPaso(4, aviso);
              this.spinner.hide();
              this.intentos = 0;
            }
            else if ( this.intentos >= GlobalConstants.reintentosSolicitud){
              this.lightboxDiv('.modal-error');
              this.subscription.unsubscribe();
              this.spinner.hide();
              this.intentos = 0;
            }else{
              this.intentos++;
            }
          },
          err => {
            console.log('ERROR: ' + err);
          }
          );

        });
        break;
      case 4:
        // Acá se debe procesar la respuesta y mandarla al componente <app-suscripcion-boleta-satisfactoria>
        //this.pasos[0]['P1'].I = false;
        this.pasos[0]['P2'].I = false;
        this.pasos[0]['P3'].I = true;
        // Acá se muestra el componente de respuesta
        this.respuesta = respuesta;
        $("app-boleta").show();
        TweenMax.to('.linea-current', 1, {
          width: '100%', onComplete: () => {
            this.pasos[0]['P2'].CurrentNum = true;
            this.pasos[0]['P3'].CurrentNum = true;
            $(".paso-3")[0].scrollIntoView();
          }
        });
        break;
    }
  }

  sendEmail(nombre: string, mail: string, requestId: string) {
    this.apiService.sendEmail(nombre, mail, requestId).subscribe(
        response => {
        //console.log('Email Enviado', response);
      },
      error => {
        console.error('Error enviando email', error);
      }
    );
  }

  onChangeRegion(obj) {
    this.spinner.show();
    if (obj) {
      this.apiService.LeerComunaRegion(obj.id_region).subscribe(res => {
        if (res.respuesta === true) {
          this.dataComuna = this.generarDataSetComuna(res.data);
          this.comuna.handleClearClick();
        }
        this.spinner.hide();
      });
    }
    else {
      this.comuna.handleClearClick();
      this.spinner.hide();
    }
  }

  generarDataSetComuna(data: any) {
    data.forEach(element => {
      element.id = element.id_comuna;
    });
    return data;
  }

  generarDataSetRegion(data: any) {
    data.forEach(element => {
      element.id = element.id_region;
    });
    return data;
  }

  validarNumeroCliente(
    control: AbstractControl
  ): Observable<{ [key: string]: any } | null> {
    if (control.value === null || control.value.length === 0) {
      return of(null);
    } else {
      this.spinner.show();
      return timer(0).pipe(
        switchMap(() => {
          return this.apiService.checkCliente(control.value).pipe(
            map(res => {
              if (res.respuesta) {

                this.formData.patchValue({
                  direccion: res.ConsultarDireccionClientePorCtaCtoResponse.Direccion,
                  region: parseInt( res.ConsultarDireccionClientePorCtaCtoResponse.Region, 10),
                  comuna: res.ConsultarDireccionClientePorCtaCtoResponse.Comuna

                });
                this.formData.controls.direccion.disable();
                this.formData.controls.region.disable();
                this.formData.controls.comuna.disable();
                this.spinner.hide();
                return null;
              }else{
                this.lightboxDiv('.modal-error-cliente');
              }
              // SI ES INCORRECTO LIMPIAR
              this.formData.patchValue({
                direccion: null,
                region: null,
                comuna: null

              });

              this.formData.controls.direccion.enable();
              this.formData.controls.region.enable();
              this.formData.controls.comuna.enable();
              this.spinner.hide();
              return { numClienteExist: true };
            })
          );
        })
      );
    }
  }

  getTextClass() {
    return { 'disabled-text': this.formData.get('suscripcion').disabled };
  }

  getCheckboxClass() {
    return { 'disabled-checkbox': this.formData.get('suscripcion').disabled };
  }

  getUserIp(): void {
  fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(data => {
      this.userIp = data.ip;
    })
    .catch(error => {
      this.userIp = '';
    });
  }
}
